import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'

import { useAccountAppContext } from '@/app/AccountAppContext'

import { LocalSecuritySection } from './local/LocalSecuritySection'
import { useSecurityData } from './useSecurityData'
import { ConnectionsSection } from './connections/ConnectionsSection'

export const Security = () => {
    const { t } = useTranslation()

    const { showError } = useAccountAppContext()
    const { data: security, isPending, error } = useSecurityData()

    useEffect(() => {
        if (error) {
            showError(error instanceof Error ? error.message : t('messages.loadError'))
        }
    }, [error, showError, t])

    if (!isPending && !security) {
        return null
    }

    return (
        <>
            <LocalSecuritySection security={security} />
            <ConnectionsSection connections={security?.connections} />
        </>
    )
}
